<ion-header class="ion-no-border app-inner-padding">
	<ion-grid class="ion-no-padding">
		<ion-row class="ion-no-padding">
			<ion-col size="6">
				<ion-title size="small" class="ion-no-padding">{{ 'entry.report.title' | translate }}</ion-title>
			</ion-col>
			<ion-col size="6">
				<ion-buttons>
					<ion-button class="ion-no-padding" (click)="close()">
						<ion-icon class="icon-Close"></ion-icon>
					</ion-button>
				</ion-buttons>
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-header>
<ion-content #content>
	<ion-grid class="ion-padding-vertical ion-align-items-stretch">
		<ion-row class="ion-justify-content-between">
			<ion-col class="ion-align-self-start">
				<ion-text class="title">{{ 'entry.report.name' | translate }}</ion-text>
			</ion-col>
			<ion-col class="ion-align-self-start">
				<ion-button class="export-button" (click)="export()">Export</ion-button>
			</ion-col>
		</ion-row>
		<ion-row class="ion-justify-content-between">
			<ion-col class="ion-align-self-start">
				<ion-text class="name">{{ reportName$() | async }}</ion-text>
			</ion-col>
		</ion-row>
		<ion-row>
			<ion-col size="12">
				<div class="horizontal-menu-wrapper">
					<app-horizontal-menu [isUsedInFooter]="false" [tables]="childTables"></app-horizontal-menu>
				</div>

				<ng-container *ngIf="childTableItems && childTableItems.length > 0; else noContent">
					<div *ngIf="!areColumnsDisplayedVertically" class="scrollable">
						<ion-row>
							<ion-col *ngFor="let childTableColumn of childTableItems[0]">
								<ion-text class="title">{{ childTableColumn.label }}</ion-text>
							</ion-col>
						</ion-row>
						<ion-row class="table-item" *ngFor="let childTableItem of childTableItems">
							<ion-col *ngFor="let item of childTableItem">
								<ion-text class="row ion-text-center">{{
									item.value | truncateText: 50 | formatEntryItem: item.valueType
								}}</ion-text>
							</ion-col>
						</ion-row>
					</div>

					<div *ngIf="areColumnsDisplayedVertically" class="scrollable">
						<ion-row class="table-item" *ngFor="let childTableItem of childTableItems[0]">
							<ion-col>
								<ion-text class="title">{{ childTableItem.label }}</ion-text>
							</ion-col>
							<ion-col>
								<ion-text class="row ion-text-center">{{
									childTableItem.value | truncateText: 50 | formatEntryItem: childTableItem.valueType
								}}</ion-text>
							</ion-col>
						</ion-row>
					</div>
				</ng-container>

				<ng-template #noContent>
					<div class="scrollable not">
						<div class="no-entity-data">
							<span>{{ 'entry.report.noRecords' | translate }}</span>
						</div>
					</div>
				</ng-template>
			</ion-col>
		</ion-row>
		<!-- <ion-row class="ion-justify-content-center">
			<ion-button (click)="signPreview()">
				<ion-text>{{ 'entry.report.sign' | translate }}</ion-text>
			</ion-button>
		</ion-row> -->
	</ion-grid>
</ion-content>
<ion-footer>
	<ion-row class="ion-justify-content-center">
		<ion-button (click)="signPreview()">
			<ion-text>{{ 'entry.report.sign' | translate }}</ion-text>
		</ion-button>
	</ion-row>
</ion-footer>
